import * as React from "react";
import type { SVGProps } from "react";
const SvgDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.6 14.4c-.536 1.676-1.882 3.017-3.6 3.6m0 3.6c-3.97 0-7.2-3.042-7.2-6.781C4.8 9.6 12 2.4 12 2.4s7.2 7.2 7.2 12.419c0 3.739-3.23 6.781-7.2 6.781"
    />
  </svg>
);
export default SvgDrop;
